import React from 'react';
import { Flex, Spinner, Text } from '@chakra-ui/react';

const LoadingSpinner = ({ message = 'Loading...' }) => {
  return (
    <Flex direction="column" align="center" justify="center" h="200px">
      <Spinner 
        thickness="4px"
        speed="0.65s"
        emptyColor="gray.700"
        color="rgba(65, 105, 225, 0.8)"
        size="xl"
      />
      <Text mt={4} color="gray.300">
        {message}
      </Text>
    </Flex>
  );
};

export default LoadingSpinner; 